/**
 * Legal URLs surfaced inside the app.
 *
 * The privacy link is not decoration — BOTH stores require it to be reachable
 * from inside the binary, not merely filed in the console:
 *
 *   - Apple App Store Review Guideline 5.1.1(i): the policy link must appear "in
 *     the App Store Connect metadata field AND within the app in an easily
 *     accessible manner".
 *   - Google Play User Data policy: a privacy policy link in the designated
 *     Play Console field, AND "a privacy policy link or text within the app
 *     itself".
 *
 * Until 2026-07 there was no privacy string anywhere in this app's source, so
 * the app shipped non-compliant on both counts regardless of what the console
 * said. It is now linked from TWO places, deliberately:
 *
 *   - Home — reachable WITHOUT an event code. A reviewer who cannot get past
 *     the code screen must still be able to find it, or "easily accessible"
 *     fails exactly when it is being assessed.
 *   - Settings — where users look for it once they are working an event.
 *
 * The URL is served by the ADMIN app (client.realguest, route /legal/privacy),
 * which is why it is a hardcoded absolute URL rather than an in-app route: one
 * policy covers the whole RealGuest platform — the admin SPA, the public event
 * websites and this app. Keep it stable; store consoles point at this exact URL
 * and a dead privacy link is a rejection on both platforms.
 */
export const PRIVACY_POLICY_URL = 'https://app.realguest.it/legal/privacy';
